export type TableRowNumberOptions = {
  /** Total rows in the filtered list (from server pagination) */
  total?: number
  /** When true and direction is desc, show global rank counting down from total */
  sequenceSortActive?: boolean
  sortDirection?: 'asc' | 'desc'
}

/** Row # for paginated tables (1-based global position in the current sort order). */
export function getTableRowNumber(
  page: number,
  perPage: number,
  index: number,
  options?: TableRowNumberOptions,
): number {
  const base =
    (Math.max(1, page) - 1) * Math.max(1, perPage) + index + 1

  const total = options?.total ?? 0
  if (
    options?.sequenceSortActive &&
    options.sortDirection === 'desc' &&
    total > 0
  ) {
    return Math.max(1, total - base + 1)
  }

  return base
}
